import { Button } from "@svea/design-system-components-react";
import {
	ButtonGroup,
	Dialog,
	FormControlLabel,
	P,
	RadioButton,
	Stack,
	useText,
} from "@sveabank/cc-common";
import { useState } from "react";
import type { CardDisplayName } from "../../types/product";

type Props = {
	open: boolean;
	setOpen: (isOpen: boolean) => void;
	cardNames: CardDisplayName[];
	selectedCardName?: string;
	onSave: (displayName: string) => void;
};

const CardDisplayNameModal = ({ open, setOpen, cardNames, selectedCardName, onSave }: Props) => {
	const [t, texts] = useText();
	const [displayName, setDisplayName] = useState(selectedCardName ?? cardNames[0]?.displayName);

	return (
		<Dialog
			isOpen={open}
			setOpen={setOpen}
			size="small"
			heading={t(texts.applicationSettings.cardSettings.modal.heading)}
		>
			<Dialog.Content>
				<Stack justify="start" gap={4}>
					<P>{t(texts.applicationSettings.cardSettings.modal.description)}</P>
					{!!cardNames?.length &&
						cardNames.map((name) => (
							<FormControlLabel label={name.displayName} key={name.displayName}>
								<RadioButton
									value={name.displayName}
									name="displayName"
									checked={displayName === name.displayName}
									onChange={(e) => {
										setDisplayName(e.currentTarget.value);
									}}
								/>
							</FormControlLabel>
						))}
				</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button
						width="full"
						onPress={() => {
							if (!displayName) throw new Error("No name on card");
							onSave(displayName);
						}}
					>
						{t(texts.applicationSettings.buttonText.save)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default CardDisplayNameModal;
